export const mockWaitingListResponse = {
  rescode: 1,
  message: 'Waiting list fetched',
  data: {
    entries: [
      {
        id: 1, patient_id: 101, therapy_id: 1, therapist_id: 3,
        preferred_days: 'Mon,Wed,Fri', preferred_time: 'Evening', sessions_per_week: 3,
        evaluation_status: 'done', priority: 'high', priority_score: 72,
        notes: 'Parent prefers Dr Neha only. Child responds well to her approach.',
        status: 'waiting', created_at: '2026-02-20T10:00:00.000Z',
        patient: { UserId: 101, FirstName: 'Aryan', LastName: 'Sharma', Phone: '9876543201', Email: 'aryan@test.com' },
        therapist: { UserId: 3, FirstName: 'Neha', LastName: 'Gupta' },
        therapy: { id: 1, name: 'Speech Therapy', color: '#7A6EFE' },
      },
      {
        id: 2, patient_id: 102, therapy_id: 2, therapist_id: null,
        preferred_days: 'Tue,Thu', preferred_time: 'Morning', sessions_per_week: 2,
        evaluation_status: 'pending', priority: 'urgent', priority_score: 88,
        notes: 'Referred by Dr Mehta — severe sensory processing issues. Needs immediate slot.',
        status: 'waiting', created_at: '2026-02-15T08:30:00.000Z',
        patient: { UserId: 102, FirstName: 'Kavya', LastName: 'Patel', Phone: '9876543202', Email: 'kavya@test.com' },
        therapist: null,
        therapy: { id: 2, name: 'Occupational Therapy', color: '#F59E0B' },
      },
      {
        id: 3, patient_id: 103, therapy_id: 1, therapist_id: 4,
        preferred_days: 'Mon,Tue,Wed,Thu,Fri', preferred_time: 'Afternoon', sessions_per_week: 5,
        evaluation_status: 'done', priority: 'high', priority_score: 65,
        notes: 'Intensive program recommended. ASD level 2 — needs daily sessions.',
        status: 'waiting', created_at: '2026-03-01T14:00:00.000Z',
        patient: { UserId: 103, FirstName: 'Rohan', LastName: 'Singh', Phone: '9876543203', Email: 'rohan@test.com' },
        therapist: { UserId: 4, FirstName: 'Rahul', LastName: 'Verma' },
        therapy: { id: 1, name: 'Speech Therapy', color: '#7A6EFE' },
      },
      {
        id: 4, patient_id: 104, therapy_id: 3, therapist_id: null,
        preferred_days: 'Sat', preferred_time: 'Morning', sessions_per_week: 1,
        evaluation_status: 'pending', priority: 'normal', priority_score: 35,
        notes: 'Weekend only — father brings child. School on weekdays.',
        status: 'waiting', created_at: '2026-03-05T09:00:00.000Z',
        patient: { UserId: 104, FirstName: 'Ananya', LastName: 'Joshi', Phone: '9876543204', Email: 'ananya@test.com' },
        therapist: null,
        therapy: { id: 3, name: 'Special Education', color: '#6366F1' },
      },
      {
        id: 5, patient_id: 105, therapy_id: 5, therapist_id: 5,
        preferred_days: 'Mon,Wed,Fri', preferred_time: 'Morning', sessions_per_week: 3,
        evaluation_status: 'done', priority: 'urgent', priority_score: 92,
        notes: 'Diagnosed ADHD + ASD. Behavior escalation reported at school. Needs ABA urgently.',
        status: 'waiting', created_at: '2026-03-10T11:00:00.000Z',
        patient: { UserId: 105, FirstName: 'Vivaan', LastName: 'Kapoor', Phone: '9876543205', Email: 'vivaan@test.com' },
        therapist: { UserId: 5, FirstName: 'Sneha', LastName: 'Nair' },
        therapy: { id: 5, name: 'ABA / Autism Therapy', color: '#EF4444' },
      },
      {
        id: 6, patient_id: 106, therapy_id: 2, therapist_id: 3,
        preferred_days: 'Tue,Thu,Sat', preferred_time: 'Afternoon', sessions_per_week: 3,
        evaluation_status: 'done', priority: 'high', priority_score: 58,
        notes: 'Delayed fine motor milestones. Handwriting support needed before school starts.',
        status: 'waiting', created_at: '2026-03-12T13:30:00.000Z',
        patient: { UserId: 106, FirstName: 'Saanvi', LastName: 'Reddy', Phone: '9876543206', Email: 'saanvi@test.com' },
        therapist: { UserId: 3, FirstName: 'Neha', LastName: 'Gupta' },
        therapy: { id: 2, name: 'Occupational Therapy', color: '#F59E0B' },
      },
      {
        id: 7, patient_id: 107, therapy_id: 6, therapist_id: null,
        preferred_days: 'Mon,Wed', preferred_time: 'Morning', sessions_per_week: 2,
        evaluation_status: 'not_required', priority: 'normal', priority_score: 28,
        notes: 'Picky eater. Only eats 3-4 food items. Feeding therapy recommended by pediatrician.',
        status: 'waiting', created_at: '2026-03-18T09:45:00.000Z',
        patient: { UserId: 107, FirstName: 'Ishaan', LastName: 'Mehta', Phone: '9876543207', Email: 'ishaan@test.com' },
        therapist: null,
        therapy: { id: 6, name: 'Feeding Therapy', color: '#EC4899' },
      },
      {
        id: 8, patient_id: 108, therapy_id: 4, therapist_id: 4,
        preferred_days: 'Mon,Tue,Wed,Thu,Fri', preferred_time: 'Afternoon', sessions_per_week: 5,
        evaluation_status: 'done', priority: 'high', priority_score: 70,
        notes: 'Pre-academic skills very low. Needs intensive special education before mainstream school admission.',
        status: 'waiting', created_at: '2026-03-22T15:00:00.000Z',
        patient: { UserId: 108, FirstName: 'Anika', LastName: 'Malhotra', Phone: '9876543208', Email: 'anika@test.com' },
        therapist: { UserId: 4, FirstName: 'Rahul', LastName: 'Verma' },
        therapy: { id: 4, name: 'Special Education', color: '#6366F1' },
      },
      {
        id: 9, patient_id: 109, therapy_id: 1, therapist_id: null,
        preferred_days: 'Thu,Fri', preferred_time: 'Evening', sessions_per_week: 2,
        evaluation_status: 'pending', priority: 'low', priority_score: 15,
        notes: 'Mild articulation — follow-up from previous center. No urgency.',
        status: 'waiting', created_at: '2026-04-01T10:00:00.000Z',
        patient: { UserId: 109, FirstName: 'Reyansh', LastName: 'Kumar', Phone: '9876543209', Email: 'reyansh@test.com' },
        therapist: null,
        therapy: { id: 1, name: 'Speech Therapy', color: '#7A6EFE' },
      },
    ],
    total: 9,
  },
};

export const mockMatchingPatientsResponse = {
  rescode: 1,
  message: 'Matching patients found',
  data: {
    entries: [
      {
        id: 2, patient_id: 102, priority_score: 88,
        preferred_days: 'Tue,Thu', preferred_time: 'Morning',
        patient: { UserId: 102, FirstName: 'Kavya', LastName: 'Patel', Phone: '9876543202' },
        therapy: { id: 2, name: 'Occupational Therapy' },
      },
      {
        id: 5, patient_id: 105, priority_score: 92,
        preferred_days: 'Mon,Wed,Fri', preferred_time: 'Morning',
        patient: { UserId: 105, FirstName: 'Vivaan', LastName: 'Kapoor', Phone: '9876543205' },
        therapy: { id: 5, name: 'ABA / Autism Therapy' },
      },
      {
        id: 1, patient_id: 101, priority_score: 72,
        preferred_days: 'Mon,Wed,Fri', preferred_time: 'Evening',
        patient: { UserId: 101, FirstName: 'Aryan', LastName: 'Sharma', Phone: '9876543201' },
        therapy: { id: 1, name: 'Speech Therapy' },
      },
    ],
    total: 3,
  },
};

export const mockPatientWaitingEntries = {
  rescode: 1,
  message: 'Patient waiting entries fetched',
  data: {
    entries: [
      {
        id: 1, therapy_id: 1, preferred_time: 'Evening', preferred_days: 'Mon,Wed,Fri',
        status: 'waiting', created_at: '2026-02-20T10:00:00.000Z',
        therapy: { id: 1, name: 'Speech Therapy', color: '#7A6EFE' },
        therapist: { UserId: 3, FirstName: 'Neha', LastName: 'Gupta' },
      },
    ],
    total: 1,
  },
};
